import React, { FC, useState, useEffect, memo } from "../../../../lib/teact/teact";
import Button from "../../../ui/Button";
import InputText from "../../../ui/InputText";
import Modal from "../../../ui/Modal";
import { CongNoApi } from "../../restapi/congNoApi";
import worker from "../../setupWorker";
import MyDateInput from "../../ui/myDateInput";
import MyTextInput from "../../ui/myTextInput";
import { getCurDate } from "../../utils/DateTimeUtils";

type OwnProps = {
   onClose: () => void;
   isOpen: boolean;
   data: any;
   onDataSaved?: () => void;
}

const NhapSuaChungTu: FC<OwnProps> = (
   {
      onClose,
      isOpen,
      data,
      onDataSaved,
   }
) => {
   const [state, setState] = useState({

      chungTu: { noiDung: "", ngay: getCurDate(), soTien: 0 },


   })
   function handleSoTienChange(e: React.ChangeEvent<HTMLInputElement>) {
      const tmp = { ...state.chungTu }
      const num = Number(e.target.value)
      tmp.soTien = 0;
      if (!isNaN(num))
         tmp.soTien = num;
      setState(prev => ({ ...prev, chungTu: tmp }))
   }
   useEffect(() => {
      if (data.chungTu)

         setState(prev => ({ ...prev, chungTu: data.chungTu, details: data.details }))
   }, [data])

   function handleSaveData() {
      const tmp = { ...state.chungTu }
      const chungTu = { ...state.chungTu }
      if (chungTu.ngay.length == 10)
         chungTu.ngay = tmp.ngay + "T00:00:00Z";
      const payload = { chungTu: chungTu }
      CongNoApi.SaveChungTu(payload).then(res => {
         if (res.errorCode == 0) {
            worker.postMessage({ type: 'showsnackbar', data: 'Lưu số liệu thành công' })
            onClose()
            if (onDataSaved)
               onDataSaved()
         }
         else {
            worker.postMessage({ type: 'showsnackbar', data: res.responseText })
         }
      })
   }
   function handleNgayChange(e: React.ChangeEvent<HTMLInputElement>) {
      const tmp = { ...state.chungTu }
      tmp.ngay = e.target.value;
      setState(prev => ({ ...prev, chungTu: tmp }))
   }
   function handleNoiDungChange(e: React.ChangeEvent<HTMLInputElement>) {
      const tmp = { ...state.chungTu }
      tmp.noiDung = e.target.value;
      setState(prev => ({ ...prev, chungTu: tmp }))
   }
   function getTitle(ctype: string): string {
      let title = ""
      switch (ctype) {
         case 'thu':
            title = 'Thu tiền của khách/chủ'
            break;
         case 'bu':
            title = 'Bù tiền cho khách/chủ'
            break;
         case 'phaithu':
            title = 'Tiền phải thu của khách/chủ'
            break;
         case 'phaitra':
            title = 'Tiền phải trả cho khách/chủ'
            break;
      }
      return title;
   }

   return (
      <Modal
         onClose={onClose}
         isOpen={isOpen}
         className="confirm"
         title={getTitle(data.ctype)}
      >
         <div className="form-content center equal-width">

            <MyDateInput label="Ngày" labelPosition="top"
               value={state.chungTu.ngay.substring(0, 10)}
               onChange={handleNgayChange}
            />


            <InputText id={"nct-so-tien"} label="Số tiền"
               value={state.chungTu.soTien}
               onChange={handleSoTienChange}
            />
            <InputText id={"nct-noi-dung"} label="Nội dung"
               value={state.chungTu.noiDung}
               onChange={handleNoiDungChange}
            />
            <div style="width:200px;">
               <Button size='tiny' onClick={handleSaveData}>Lưu</Button>
            </div>
         </div>
      </Modal>
   )
}

export default memo(NhapSuaChungTu)